import { AccountItem } from "@store/sessions/types";

export const getAccountId = (accounts: AccountItem[], account: string) => {
  const accountItem = accounts.find((item) => item.accountName === account);
  return accountItem ? accountItem.accountId : "";
};
